import React from 'react';
import PropTypes from 'prop-types';
import { Collapsible } from '@fiverr-private/fit';

import withTranslation from '../../../../../../HOCs/withTranslation';
import { TeamLink } from '../../../../CustomLinks';
import { COPIES } from '../../../../../../constants';
import {
    COLLAPSIBLE_CLASS,
    COLLAPSIBLE_CHEVRON_WRAPPER_CLASS,
    COLLAPSIBLE_TITLE_WRAPPER_CLASS,
    COLLAPSIBLE_CONTENT_CLASS,
} from './constants';

import './style.scss';

const Teams = ({ teams }) => (
    <div className="sidebar-teams">
        <Collapsible
            defaultExpanded={true}
            className={COLLAPSIBLE_CLASS}
            titleWrapperClassName={COLLAPSIBLE_TITLE_WRAPPER_CLASS}
            chevronWrapperClassName={COLLAPSIBLE_CHEVRON_WRAPPER_CLASS}
            contentClassName={COLLAPSIBLE_CONTENT_CLASS}
            title={COPIES.teamsLabel}
        >
            <ul>
                {teams.map((team) => (
                    <li key={team.link}>
                        <TeamLink team={team} />
                    </li>
                ))}
            </ul>
        </Collapsible>
    </div>
);

Teams.propTypes = {
    teams: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
            link: PropTypes.string,
        })
    ),
};

Teams.defaultProps = {
    teams: [],
};

export default withTranslation(Teams);
